// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"7ad08059","328":"fd6ba730","407":"b0944566","488":"ed0dd99a","690":"a8623198","814":"8ab584c8"}[chunkId] + ".chunk.js";
};